import { getLocalAlbumIndexSessionMeta } from '../services/libraryAlbumIndex';
import { shouldUseLocalLibraryIpc } from '../services/localLibraryIpcGate';
import { useLibraryCacheStore } from '../store/libraryCacheStore';
import { resetArtistEnrichmentCatalogCacheForTests } from './artistEnrichmentCatalogCache';
import { resetArtistBrowseMaterializationForTests } from '../utils/artistBrowseMaterialization';
import { resetArtistBrowseIndexCacheForTests } from '../utils/artistBrowseIndex';
import { resetGroupedArtistsCacheForTests } from '../utils/artistGrouping';
import { resetSortAlbumsCacheForTests } from '../utils/formatDetection';

/** Stable catalog revision for browse memoization — invalidated on catalog-changed. */
export function getLibraryCatalogRevision(fallbackAlbumCount = 0): string {
  const meta = shouldUseLocalLibraryIpc() ? getLocalAlbumIndexSessionMeta() : null;
  return String(
    meta?.gridFingerprint
    ?? meta?.catalogVersion
    ?? useLibraryCacheStore.getState().version
    ?? fallbackAlbumCount,
  );
}

export function invalidateLibraryBrowseCaches(): void {
  resetArtistBrowseMaterializationForTests();
  resetArtistBrowseIndexCacheForTests();
  resetGroupedArtistsCacheForTests();
  resetSortAlbumsCacheForTests();
  resetArtistEnrichmentCatalogCacheForTests();
}

let invalidationInstalled = false;

/** Wire once — maestro:library:changed clears browse memo caches. */
export function installLibraryBrowseCacheInvalidation(): () => void {
  if (invalidationInstalled || typeof window === 'undefined') return () => {};
  invalidationInstalled = true;
  const handler = () => invalidateLibraryBrowseCaches();
  window.addEventListener('maestro:library:changed', handler);
  return () => {
    invalidationInstalled = false;
    window.removeEventListener('maestro:library:changed', handler);
  };
}

export function resetLibraryBrowseCacheInvalidationForTests(): void {
  invalidationInstalled = false;
}
